import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=d73e92e0"
import script from "./AccountSetup.vue?vue&type=script&lang=ts"
export * from "./AccountSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports